export class SubMenu {

    constructor ( target = '.js-sub-menu__toggle', options = {} ) {
        this.target = target;
        this.options = {
            showClass: 'js-sub-menu--show',
            hideClass: 'js-sub-menu--hide',
            closeTrigger: '.js-sub-menu__close',
            ...options
        }
    }

    init() {
        this.$triggers = Array.from( document.querySelectorAll( this.target ) );
        this.$close = document.querySelector( this.options.closeTrigger );

        this.$triggers.forEach( $trigger => {
            if( $trigger.dataset.target ) {
                $trigger.addEventListener('click', this.toggle.bind( this, $trigger ) );
            }
        });

        this.$close.addEventListener('click', this.close.bind( this ) );
    }

    toggle( $trigger, e ) {
        e.preventDefault();

        this.$target = document.getElementById( $trigger.dataset.target );
        this.$parent = $trigger.closest('.js-sub-menu__primary');

        this.$target.classList.toggle( this.options.showClass );
        this.$parent.classList.toggle( this.options.hideClass );
    }

    close() {
        document.querySelector('.js-sub-menu__primary').classList.toggle( this.options.hideClass );
        document.querySelector('.js-sub-menu__secondary').classList.toggle( this.options.showClass );
    }
}